function OfficesMap(el) {
    this.el = el;
    this.modalEl = null;

    this.el.addEventListener('click', e => {
        if (e.target.tagName.toLowerCase() === 'button') this.showModal(JSON.parse(e.target.dataset.obj));
    });
}

OfficesMap.prototype.createModal = function() {
    if (this.modalEl !== null) return;

    this.modalEl = document.createElement('div');
    this.modalEl.classList.add('office-project-modal');
    this.modalEl.classList.add('jsCloseModal');

    const innerEl = document.createElement('div');
    innerEl.classList.add('office-project-modal__inner');
    this.modalEl.appendChild(innerEl);

    innerEl.innerHTML = '' +
        '<div class="office-project-modal__logo jsLogo"></div>' +
        '<button class="office-project-modal__close-btn jsCloseModal" type="button">Sluiten</button>' +
        '<span class="office-project-modal__title jsTitle"></span>' +

        '<div class="office-project-modal__offices jsOffices">' +
            '<span class="office-project-modal__subtitle">' + officesNameString + '</span>' +
            '<ul></ul>' +
        '</div>' +

        '<div class="office-project-modal__programs jsPrograms">' +
            '<span class="office-project-modal__subtitle">' + programsNameString + '</span>' +
            '<ul></ul>' +
        '</div>' +

        '<div class="office-project-modal__item-display jsItemDisplay">' +
            '<button type="button" class="office-project-modal__back-btn btn btn--arrow-reverse btn--trans btn--medium text-color-black jsBackBtn">' + officeProjectModalBackText + '</button>' +
            '<span class="office-project-modal__subtitle jsItemDisplaySubtitle">AAA!</span>' +
            '<span class="office-project-modal__title jsItemDisplayTitle">BBB!!</span>' +
            '<div class="office-project-modal__address default-styles jsItemDisplayAddress">BBB!!</div>' +
            '<a href="" target="" class="office-project-modal__cta btn btn--arrow bg-color-purple-1-2 text-color-white jsitemDisplayCta"></a>'
        '</div>'
    ;

    document.body.appendChild(this.modalEl);

    // Init event listeners
    this.modalEl.addEventListener('click', e => {
        if(e.target.classList.contains('jsCloseModal')) this.hideModal();
        else if (e.target.classList.contains('jsShowItem')) this.showItem(e.target);
        else if (e.target.classList.contains('jsBackBtn')) {
            const itemDisplayEl = this.modalEl.querySelector('.jsItemDisplay');
            const titleEl = this.modalEl.querySelector('.jsTitle');
            const officesEl = this.modalEl.querySelector('.jsOffices');
            const programsEl = this.modalEl.querySelector('.jsPrograms');
            const logoEl = this.modalEl.querySelector('.jsLogo');

            itemDisplayEl.style.display = 'none';
            titleEl.style.display = '';
            officesEl.style.display = '';
            programsEl.style.display = '';
            logoEl.innerHTML = '';
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hideModal();
    });
};

OfficesMap.prototype.showModal = function(data) {
    this.createModal();

    const itemDisplayEl = this.modalEl.querySelector('.jsItemDisplay');
    const titleEl = this.modalEl.querySelector('.jsTitle');
    const officesEl = this.modalEl.querySelector('.jsOffices');
    const programsEl = this.modalEl.querySelector('.jsPrograms');

    data.offices = Object.values(data.offices);
    data.programs = Object.values(data.programs);

    itemDisplayEl.style.display = '';
    titleEl.innerHTML = data.title;


    // Show the offices
    if (data.offices.length > 0) {
        const ulEl = officesEl.querySelector('ul');

        ulEl.innerHTML = '';
        data.offices.forEach(office => ulEl.innerHTML += "<li><button type='button' class='jsShowItem' data-obj='" + JSON.stringify(office) + "'>" + office.title + "</button></li>");
        officesEl.style.display = '';
    }
    else {
        officesEl.style.display = 'none';
    }

    // Show the programs
    if (data.programs.length > 0) {
        const ulEl = programsEl.querySelector('ul');

        ulEl.innerHTML = '';
        data.programs.forEach(program => ulEl.innerHTML += '<li><a href="' + program.url + '">' + program.title + '</a></li>');
        programsEl.style.display = '';
    }
    else {
        programsEl.style.display = 'none';
    }

    document.body.classList.add('no-overflow');
    this.modalEl.classList.add('visible');
};

OfficesMap.prototype.hideModal = function() {
    this.modalEl.classList.remove('visible');
    document.body.classList.remove('no-overflow');
};

OfficesMap.prototype.showItem = function(itemEl) {
    const data = JSON.parse(itemEl.dataset.obj);

    const itemDisplayEl = this.modalEl.querySelector('.jsItemDisplay');
    const itemDisplaySubtitleEl = itemDisplayEl.querySelector('.jsItemDisplaySubtitle');
    const itemDisplayTitleEl = itemDisplayEl.querySelector('.jsItemDisplayTitle');
    const itemDisplayAddressEl = itemDisplayEl.querySelector('.jsItemDisplayAddress');
    const itemDisplayCtaEl = itemDisplayEl.querySelector('.jsitemDisplayCta');
    const titleEl = this.modalEl.querySelector('.jsTitle');
    const officesEl = this.modalEl.querySelector('.jsOffices');
    const programsEl = this.modalEl.querySelector('.jsPrograms');
    const logoEl = this.modalEl.querySelector('.jsLogo');

    // Insert the content
    itemDisplaySubtitleEl.innerHTML = data.type == 'program' ? programNameString : officeNameString;
    itemDisplayTitleEl.innerHTML = data.title;

    itemDisplayAddressEl.innerHTML = data.type === 'program' ? data.country : data.address + '<br/>' + data.zipcode_location + '<br/>' + data.office_country
    itemDisplayAddressEl.innerHTML = '<p>' + itemDisplayAddressEl.innerHTML + '</p>';

    // Set the CTA-button
    if (data.btn !== '') {
        itemDisplayCtaEl.style.display = '';
        itemDisplayCtaEl.innerHTML = data.btn.title;
        itemDisplayCtaEl.href = data.btn.url;
        itemDisplayCtaEl.target = data.btn.target;
    }
    else {
        itemDisplayCtaEl.style.display = 'none';
    }
    
    // Show the logo
    logoEl.innerHTML = '';
    if (data.logo) logoEl.innerHTML = '<img src="' + data.logo + '" alt="' + data.title + '" />';

    // Show/hide the correct items
    itemDisplayEl.style.display = 'block';
    titleEl.style.display = 'none';
    officesEl.style.display = 'none';
    programsEl.style.display = 'none';
};


(function() {
    const map = document.querySelector('.jsOfficesMap');
    if (map) new OfficesMap(map);
})();
